<template>
    <base-button
        @click.native="back"
        type="button"
        role="button"
        class="mt-3 lg:mt-0 w-full lg:w-auto flex items-center font-division-heading font-bold text-zinc-500 uppercase transition-colors border border-zinc-500 bg-transparent hover:bg-slate-100 focus:outline-none focus:ring-2 ring-brand-blue ring-offset-2 leading-none"
    >
        <i class="fa fa-chevron-left mr-2"></i>
        Back
    </base-button>
</template>

<script>
export default {
    methods: {
        back() {
            this.$event.$emit('step:previous');
        }
    }
};
</script>
